import markets from "@/config/markets";
import type { MarketEnum } from "@/config/markets/const";
import { z } from "zod";

const marketCodeSchema = {} as Record<MarketEnum, z.ZodNumber>;

markets.forEach((market) => {
  marketCodeSchema[market.code] = z.number();
});

export const minimumOrderValueSchema = z.object(marketCodeSchema);

export type MinimumOrderValue = z.infer<typeof minimumOrderValueSchema>;
